/**
 * List of the number of milliseconds in common time units.
 * E.g. 1s = 1000ms, so TIME.S === 1000
 */
export const TIME = {
  MS: 1,
  S:  1000,
  M:  1000 * 60,
  H:  1000 * 60 * 60,
  D:  1000 * 60 * 60 * 24,
  W:  1000 * 60 * 60 * 24 * 7,
};


export const BENCHMARKS = {
  UNIX_EPOCH: new Date(1970, 0, 1, 0, 0, 0, 0),
  MS_EPOCH:   new Date('0001-01-01T00:00:00'),
  Y2K:        new Date('2000-01-01T00:00:00'),
};


/**
 * Returns the number of milliseconds between startDate and endDate.
 * Order matters -- you'll get a negative number if startDate is in the past relative to endDate
 */
export const diffMs = (
  startDate: string | Date,
  endDate: string | Date,
): number => new Date(startDate).getTime() - new Date(endDate).getTime();


/**
 * Returns the number of seconds between startDate and endDate.
 * Order matters -- you'll get a negative number if startDate is in the past relative to endDate
 */
export const diffS = (
  startDate: string | Date,
  endDate: string | Date,
): number => Math.floor((new Date(startDate).getTime() - new Date(endDate).getTime()) / TIME.S);


/**
 * Checks whether the given date is 'valid' or a placeholder based on the same heuristic utilized in the previous
 * incarnation of the app.
 *
 * @param date - the date (or date string) to be examined
 */
export const isValidDate = (date: string | Date): boolean => new Date(date).getFullYear() > 1900;


/**
 * Microsoft thought it would be different and not use the Unix Epoch. So, this tests for the MS Epoch i.e. 01-01-0001
 */
export const isDotNetDefault = (
  date: string | Date,
): boolean => new Date(date).getTime() === BENCHMARKS.MS_EPOCH.getTime();
